import AdminKeyboard from "./../AdminKeyboard";
import store from '../Lightbox/LightboxStore'
import { blueyetiStates } from './../../utils/blueyetiStates'
import { sync } from 'vuex-pathify'
import axios from 'axios'
import '@/utils/pretty-checkbox/pretty-checkbox.scss';

export default {
  name: 'admin-ui',
  components: { AdminKeyboard },
  mixins: [blueyetiStates],
  props: [],
  data () {
    return {
      code: "",
    }
  },
  computed: {
     adminCode:  sync('settings@adminCode'),
     printerEnable: sync('settings@printer'),
     is_dev_mode:sync('is_dev_mode'),
     is_idle:sync('is_idle'),
     host_address:sync('host_address'),
     api_address:sync('api_address'),
     token:sync('token')
 },
 watch: {
    printerEnable: function(id) {
       this.updatePrinterSettings();
    },
 },
  mounted () {

  },
  methods: {
     // keyboard methods
     onChange(input) {
      this.code = input;
      //console.log("onChange ", this.code);
     },
     onKeyPress(button) {
        //console.log("button", button);
        //console.log("this.adminCode ", this.adminCode);
      if(button == "{enter}") {
         if(this.code == this.adminCode) {
            this.code = "";
            this.byst_SetState('gallery/admin/idle');
         }
         else {
            this.code = "";
            location.reload(true);
            //this.byst_SetState('gallery');
         }
      }
     },
     onInputChange(input) {
      this.code = input.target.value;
      //console.log("onInputChange ", this.code);
   },
   blurInput() {
     this.$refs.passwordInput.blur();
  },
  updatePrinterSettings: function() {

     const that = this;

     axios.post( this.api_address + 'updatesettings', {
        token:that.token,
        setting: "printer_on",
        value: that.printerEnable,
     }, {
         headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${process.env.VUE_APP_PUBLIC_API_TOKEN}`
         }
      })
     .then(function (response) {
        console.log("response " + response.data);
        // console.log(response);
        // console.log(response.data);
        // console.log(JSON.parse(response.data).id);

     })
     .catch(function (error) {
        console.log(error);
     });
  },
  reloadPopbook() {
     // hard reload
    location.reload(true);
   },
   quitPopbook() {
      self.close();
   },

  }
}
